import { renderApp } from 'shared/app/AppRenderer';
import { initHeapCarrierGuidSync } from 'shared/helpers/Analytics';
import { CarrierWebviewApp } from './CarrierWebviewAppRoutes';

initHeapCarrierGuidSync();

renderApp(<CarrierWebviewApp />);
